import { Component } from '@angular/core';
import {environment} from '@app/environments/environment';

@Component({
  templateUrl: './footer.html',
  selector: 'main-footer'
})
export class FooterComponent {
  public version: string;
  constructor()  {
    this.version = environment.version;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/components/footer/footer.component.ts